<template>
    <div class="hd_box">
        <h3>栏目配置</h3>
        <p class="desc">配置用于栏目信息配置</p>
    </div>
    <div class="box_container">
        <el-table :data="tableData" style="width: 100%" height="700">
            <el-table-column prop="id" label="ID" align="center" />
            <el-table-column prop="name" label="名称" align="center" />
            <el-table-column prop="is_show" label="状态" align="center">
                <template v-slot="{ row }">
                    <el-switch v-model="row.is_show" />
                </template>
            </el-table-column>
            <el-table-column prop="action" label="操作" fixed="right" width="250">
                <template #default="scope">
                    <el-button type="primary" size="small" @click="editColumn(scope.row)">编辑</el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
    <el-dialog v-model="dialogVisible" title="编辑栏目" @close="reset(formLabelAlignRef)">
        <!-- <img  :src="formLabelAlign.logo" /> -->
        <el-form label-position="left" label-width="auto" :model="formLabelAlign" ref="formLabelAlignRef">
            <el-form-item label="栏目名称" prop="name">
                <el-input v-model="formLabelAlign.name" />
            </el-form-item>
            <el-form-item label="SEO标题" prop="seo_title">
                <el-input v-model="formLabelAlign.seo_title" />
            </el-form-item>
            <el-form-item label="SEO关键字" prop="seo_keywords">
                <el-input v-model="formLabelAlign.seo_keywords" />
            </el-form-item>
            <el-form-item label="SEO描述" prop="seo_description">
                <el-input v-model="formLabelAlign.seo_description" type="textarea" />
            </el-form-item>
            <el-form-item label="是否显示">
                <el-switch v-model="formLabelAlign.is_show" />
            </el-form-item>
        </el-form>
        <template #footer>
            <div class="dialog-footer">
                <el-button @click="reset(formLabelAlignRef)">取消</el-button>
                <el-button type="primary" @click="creatFilm(formLabelAlignRef)">
                    确认
                </el-button>
            </div>
        </template>
    </el-dialog>
</template>

<script setup>
import '@wangeditor/editor/dist/css/style.css' // 引入 css
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import { ElMessage } from "element-plus";
import { Plus } from '@element-plus/icons-vue'
import { getCurrentInstance, reactive, ref, onBeforeUnmount, shallowRef, onMounted } from 'vue'
import { columnList,industryNews } from '@/api/user.js'
const formLabelAlignRef = ref()
let isadd = ref(true)
const dialogVisible = ref(false)
const planVisible = ref(false)
const addplanVisible = ref(false)
const priceVisible = ref(false)
const editorRef = shallowRef()
const toolbarConfig = {}
const editorConfig = { placeholder: '请输入内容...', MENU_CONF: {} }
editorConfig.MENU_CONF['uploadImage'] = {
    server: 'https://kjlm.unions9.com/upload/index',
    timeout: 5 * 1000,
    fieldName: 'image',
    customInsert(res, insertFn) {
        console.log(res)
        if (res.status == 200) {
            insertFn(res.data.path, null, res.data.path);
        }
    },
}
const handleCreated = (editor) => {
    editorRef.value = editor // 记录 editor 实例，重要！
}
//剧目ID
let FilmID = ref(0)
//剧目表单
let formLabelAlign = reactive({
    name: "",
    seo_description: '',
    seo_keywords: "",
    seo_title: '',
    is_show: false
})
//剧目查询
const onSubmit = () => {
    console.log('我是查询')
}
let searchForm = reactive({})
//剧目表单规则
const Dramarules = reactive({
    link: [
        { required: true, message: '请输入跳转链接', trigger: 'blur' },
    ],
})
let tableData = ref([])
let plantableData = ref([])
let currentPage = ref(1);
//获取列表参数
const getData = () => {
    columnList()
        .then(res => {
            console.log(res)
            tableData.value = res;
            // total.value = res.data.total;
            // tableData.value = res.data.data;
            // console.log(tableData);
        })
}
getData();
//翻页函数
const changepage = (data) => {
    console.log(data);
    currentPage.value = data;
    getData();
}
//新增剧目or编辑剧目
const creatFilm =(formEl) => {
    industryNews(formLabelAlign)
    .then(res=>{
        ElMessage.success('更新成功');
        dialogVisible.value=false;
        getData();

    })

}
const reset = (formEl) => {
    formEl.resetFields()
    dialogVisible.value = false;
}
const editColumn = (row) => {
    console.log(row)
    for (const key in row) {
        formLabelAlign[key] = row[key];
    }
    dialogVisible.value = true;
}


</script>

<style lang="scss" scoped>
.demo-form-inline .el-input {
    --el-input-width: 220px;
}

.demo-form-inline .el-select {
    --el-select-width: 220px;
}

.avatar {
    width: 400px;
    height: 400px;
}

.threehidden {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all
}

.avator {
    width: 140px;
}

.hd_box {
    background-color: white;
    border-radius: 10px;
    box-shadow: 0 0 10px #eee;
    padding: 10px 30px;
}

h3 {
    margin-bottom: 20px;
}

.desc {
    color: #aaa;
    font-size: 14px;
}

.box_container {
    margin-top: 30px;
    background-color: white;
    border-radius: 10px;
    box-shadow: #eee;
    padding: 10px 30px;

    .flex {
        display: flex;
        align-items: center;
        width: 200px;
        justify-content: space-between;
        margin: auto;
    }
}
</style>